import { useState } from "react";

export interface RewardSummary {
  available_reward_balance: number;
  policy: {
    property_pool_rate: number;
    other_pool_rate: number;
    level_ratios: number[];
    posting_delay_hours: number;
  };
  direct_invites_total: number;
  direct_invites_page: number;
  direct_invites_page_count: number;
  direct_invites: Array<{
    id: string;
    name: string;
    mobile: string;
    registered_at: string;
    contribution_amount: number;
  }>;
  records_total: number;
  records_page: number;
  records_page_count: number;
  records: Array<{
    id: string;
    level: number;
    amount: number;
    product_name: string;
    source_name: string;
    created_at: string;
  }>;
}

const money = (value: number) => `¥${value.toLocaleString("zh-CN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
const REWARD_ITEMS_PER_PAGE = 10;

export function paginationPageNumbers(page: number, pageCount: number): number[] {
  const visibleCount = Math.min(5, pageCount);
  const start = Math.min(Math.max(1, page - 2), Math.max(1, pageCount - visibleCount + 1));
  return Array.from({ length: visibleCount }, (_, index) => start + index);
}

function RewardPagination({
  label,
  total,
  page,
  pageCount,
  onPageChange,
}: {
  label: string;
  total: number;
  page: number;
  pageCount: number;
  onPageChange: (page: number) => void;
}) {
  return <nav className="personal-recharge-pagination personal-reward-pagination" aria-label={label}>
    <span>共 {total} 条，每页 {REWARD_ITEMS_PER_PAGE} 条</span>
    <div>
      <button type="button" disabled={page === 1} onClick={() => onPageChange(page - 1)}>上一页</button>
      {paginationPageNumbers(page, pageCount).map((pageNumber) => <button type="button" key={pageNumber} className={pageNumber === page ? "is-current" : ""} aria-current={pageNumber === page ? "page" : undefined} onClick={() => onPageChange(pageNumber)}>{pageNumber}</button>)}
      <button type="button" disabled={page === pageCount} onClick={() => onPageChange(page + 1)}>下一页</button>
    </div>
  </nav>;
}

export function MyRewards({ summary, onInvitePageChange, onRecordPageChange }: {
  summary: RewardSummary;
  onInvitePageChange?: (page: number) => Promise<void>;
  onRecordPageChange?: (page: number) => Promise<void>;
}) {
  const [tab, setTab] = useState<"invites" | "records">("invites");

  return <section className="personal-lawyer-panel personal-rewards-panel" aria-label="我的奖励">
    <div className="personal-reward-overview">
      <article><span>当前可用奖励余额</span><strong>{money(summary.available_reward_balance)}</strong><small>奖励余额仅限平台内购买产品和服务</small></article>
      <article><h2>奖励政策</h2><p>不动产产品按实际付款部分的 {summary.policy.property_pool_rate}% 进入奖励池，其他产品为 {summary.policy.other_pool_rate}%。</p><p>三级奖励比例 {summary.policy.level_ratios.join(" : ")}，订单完成 {summary.policy.posting_delay_hours} 小时且无退款后到账。</p></article>
    </div>
    <div className="personal-reward-tabs"><button className={tab === "invites" ? "is-active" : ""} type="button" onClick={() => setTab("invites")}>邀请的律师</button><button className={tab === "records" ? "is-active" : ""} type="button" onClick={() => setTab("records")}>奖励记录</button></div>
    {tab === "invites" ? <div className="personal-reward-list"><div className="personal-wallet-ledger"><table><thead><tr><th>律师姓名</th><th>手机号</th><th>注册时间</th><th>订单贡献汇总</th></tr></thead><tbody>{summary.direct_invites.map((item) => <tr key={item.id}><td>{item.name}</td><td>{item.mobile}</td><td>{new Date(item.registered_at).toLocaleString("zh-CN")}</td><td>{money(item.contribution_amount)}</td></tr>)}</tbody></table></div><RewardPagination label="邀请律师分页" total={summary.direct_invites_total} page={summary.direct_invites_page} pageCount={summary.direct_invites_page_count} onPageChange={(page) => void onInvitePageChange?.(page)} /></div> : <div className="personal-reward-list"><div className="personal-wallet-ledger"><table><thead><tr><th>时间</th><th>来源</th><th>产品</th><th>层级</th><th>奖励金额</th></tr></thead><tbody>{summary.records.map((item) => <tr key={item.id}><td>{new Date(item.created_at).toLocaleString("zh-CN")}</td><td>{item.source_name}</td><td>{item.product_name}</td><td>第 {item.level} 级</td><td className="is-credit">+{money(item.amount)}</td></tr>)}</tbody></table></div><RewardPagination label="奖励记录分页" total={summary.records_total} page={summary.records_page} pageCount={summary.records_page_count} onPageChange={(page) => void onRecordPageChange?.(page)} /></div>}
  </section>;
}
